import PubSub from 'pubsub-js';
import $ from 'jquery';
import config from './config';
import formatId from './formatId';

function getRootUrl ()
{
    return `https://${config.domain}`;
}

function isFunction ( callback )
{
    return typeof callback === "function";
}

/*
function longPolling ( url, callback )
{
    const lp = ( url ) =>
    {
        $.ajax ( {
            method: 'GET',
            url: url,
            complete: req =>
            {
                if ( req.status !== 200 )
                {
                    setTimeout ( () =>
                    {
                        lp ( url );
                    }, req.status === 400 ? 2000 : 100 );
                }
            },
            timeout: 5000
        } )
            .done ( isFunction ( callback ) ? callback : () => {} )
            .fail ( error =>
            {
                PubSub.publish ( "ws.error", error );
            } );
    };

    lp ( url );
};
*/

function simplePolling ( url, callback )
{
    const sp = ( url ) =>
    {
        $.ajax ( {
            method: 'GET',
            url: url,
            complete: req =>
            {
                if ( req.status !== 200 )
                {
                    setTimeout ( () =>
                    {
                        sp ( url );
                    }, 6000 );
                }
            }
        } )
            .done ( result =>
            {
                if ( result )
                {
                    callback ( result );
                }
            } )
            .fail ( error =>
            {
                PubSub.publish ( "ws.error", error );
            } );
    };

    sp ( url );
};

export function getLinkData ( key, callback )
{
    $.ajax ( {
        method: 'GET',
        url: `${getRootUrl ()}/rest/link/${key}`,
        data: {
            app: config.app,
            sig: config.signature
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}

export function setCallData ( data, callback )
{
    $.ajax ( {
        method: "POST",
        url: `${getRootUrl ()}/rest/call/user`,
        data: {
            key: data.key,
            room: data.room,
            user: data.userName
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
};

export function pollingCallRoom ( key, callback )
{
    simplePolling ( `${getRootUrl ()}/rest/call/poll/${key}`, isFunction ( callback ) ? callback : () => {} ); 
    //longPolling ( `${getRootUrl ()}/rest/call/poll/${key}`, isFunction ( callback ) ? callback : () => {} );
}

export function createRemoteCamSession ( data, callback )
{
    $.ajax ( {
        method: "POST",
        url: `${getRootUrl ()}/rest/remotecam`,
        data: {
            key: data.key,
            name: data.userName,
            sessionId: formatId ( data.userId )
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}

export function deleteRemoteCamSession ( code, callback )
{
    $.ajax ( {
        method: "POST",
        url: `${getRootUrl ()}/rest/remotecam/${code}`
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}

export function getQrCodeSrc ( code )
{
    return `${getRootUrl ()}/cam/${code}/qrcode`;
}

export function sendScore ( data, callback )
{
    $.ajax ( {
        method: "POST",
        url: `${getRootUrl ()}/rest/call/score`,
        data: {
            key: data.key,
            room: data.room,
            score: data.score
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}

export function sendErrorLog ( data, callback )
{
    $.ajax ( {
        method: "POST",
        url: `${getRootUrl ()}/rest/call/error`,
        data: {
            key: data.key,
            room: data.room,
            uid: data.id,
            pid: data.pid,
            client: data.client,
            remclient: data.remclient,
            log: data.log
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}

export function createInvoice ( data, callback )
{
    $.ajax ( {
        method: "POST",
        url: `${getRootUrl ()}/rest/invoice`,
        data: {
            customer: data.customer,
            email: data.email,
            description: data.description,
            teledate: data.teledate,
            teleutcOffset: data.teleutcOffset,
            duedate: data.duedate,
            utcOffset: data.utcOffset,
            amount: data.amount,
            language: data.lang
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}

export function exitCall ( key )
{
    return `${getRootUrl ()}/${key}/quit`;
}

export function testCallCapabilities ()
{
    return "";
}

export function startEchoSession ( data, callback )
{
    $.ajax ( {
        method: "POST",
        url: `https://${config.testsDomain}/session/start`,
        data: {
            appId: data.appId,
            appKey: data.appKey,
            offerAudio: data.offerAudio,
            offerVideo: data.offerVideo
        }
    } )
        .done ( isFunction ( callback ) ? callback : () => {} )
        .fail ( error =>
        {
            PubSub.publish ( "ws.error", error );
        } );
}